import { AppConfig } from '../types';

export const CONFIG: AppConfig = {
  // API Configuration
  // Detect if we're on localhost or local network, use local backend
  // Otherwise use production backend
  API_BASE_URL: (() => {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isLocalNetwork = /^(192\.168\.|10\.|172\.(1[6-9]|2[0-9]|3[01])\.)/.test(hostname);
    
    if (isLocalhost || isLocalNetwork) {
      // Use the same hostname but port 3001 for backend
      return `http://${hostname}:3001`;
    }
    return 'https://chat.eir.space'; // Production backend
  })(),
  
  // Chat Configuration
  CHAT: {
    MAX_MESSAGE_LENGTH: 1000,
    TYPING_DELAY: 1000,
    MAX_MESSAGES: 50
  },
  
  // UI Configuration
  UI: {
    ANIMATION_DURATION: 300,
    DEBOUNCE_DELAY: 300
  },

  EHR: {
    POLL_INTERVAL_MS: 2000, // Poll every 2 seconds
    QR_REFRESH_INTERVAL_MS: 25000
  }
};
